<mat-form-field #formFieldContainer class="qr-code-generator-class " >
  <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>

  <div class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{componentDefinition.label}}"
    [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>

  <input matInput placeholder="{{ componentDefinition?.label }}" [hidden]="componentDefinition?.hideQrText"
         [id]="elementName" [name]="componentDefinition?.name"
         [formControl]="formControl"
         [errorStateMatcher]="matcher">
  <button type="button" *ngIf="fieldValue" (click)="changeQrImage()" mat-icon-button matSuffix
          [hidden]="componentDefinition?.hideQrText" title="Generate New Qr Image" class="ft-qr-generator-icon">
    <mat-icon color="primary">
      <svg style="width:24px;" viewBox="0 0 24 24">
        <path fill="#000000"
              d="M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z"/>
      </svg>
    </mat-icon>
  </button>
  <button type="button" mat-stroked-button color="primary" [hidden]="!componentDefinition?.hideQrText"
          class="btnGeneratorCode"
          title="Generate New Qr Image"
          *ngIf="oldDocQrText!==fieldValue" (click)="changeQrImage()"
          [disabled]="disabled">
    <mat-icon>
      <svg style="width:24px;" viewBox="0 0 24 24">
        <path fill="#000000"
              d="M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z"/>
      </svg>
    </mat-icon>
     <span>Generate Code</span>
  </button>
</mat-form-field>
<img alt=" QrCode Image " *ngIf="fieldValue" class="qrImageClass" [src]="base64Image"
     title="{{fieldValue}}"/>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
